import { Dialog } from '@material-ui/core'
import CrossIcon from 'assets/img/cross.svg'
import { ActivitiesComponent } from 'components'
import * as React from 'react'
import ReactSVG from 'react-svg'
import { _route } from 'routes/config'

interface IProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  currentChild: any
  havePhoneNumber: any
  isUserForwardFromHeader: boolean
  history: any
}

export const ActivitiesModal: React.FC<IProps> = ({
  open,
  onClose,
  onSubmit,
  currentChild,
  havePhoneNumber,
  isUserForwardFromHeader,
  history
}: IProps) => {
  const fullScreen = () => true
  const parentId = Object.keys(currentChild.parents)[0]

  const onBackBrowserBtnEvent = event => {
    if (!isUserForwardFromHeader) {
      goToAbilities()
    } else {
      event.preventDefault()
      onClose()
      window.removeEventListener('popstate', onBackBrowserBtnEvent)
    }
  }

  const goToAbilities = () => {
    window.removeEventListener('popstate', onBackBrowserBtnEvent)
    history.push(_route.abilities(currentChild.patientId))
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!isUserForwardFromHeader) {
          goToAbilities()
        } else {
          window.removeEventListener('popstate', onBackBrowserBtnEvent)
          onClose()
        }
      }}
      onSubmit={() => {
        onSubmit()
      }}
      fullScreen={fullScreen()}
      onEnter={() => {
        window.history.pushState(null, '', window.location.pathname)
        window.addEventListener('popstate', onBackBrowserBtnEvent)
      }}
    >
      <ActivitiesComponent
        parentId={parentId}
        onClose={() => {
          onClose()
        }}
        havePhoneNumber={havePhoneNumber}
        isUserForwardFromHeader={isUserForwardFromHeader}
        goToAbilities={() => goToAbilities()}
      />

      <div
        className="cross-icon"
        onClick={() => {
          if (!isUserForwardFromHeader) {
            goToAbilities()
          } else {
            window.removeEventListener('popstate', onBackBrowserBtnEvent)
            onClose()
          }
        }}
      >
        <ReactSVG src={CrossIcon} />
      </div>
    </Dialog>
  )
}
export default ActivitiesModal



// WEBPACK FOOTER //
// ./src/components/ActivitiesModal/index.tsx